import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import IdentityFormFields from './IdentityFormFields'
import IdentityDataError from './IdentityDataError'
import useIdentity from './useIdentity'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'
import { styled } from 'baseui'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { PulseSubhead } from '@/shared/components/PulseScope/styled-components'

const SectionTitle = styled('p', ({ $theme }) => ({
  ...$theme.typography.LabelMedium,
  color: $theme.colors.contentPrimary,
  marginTop: '1rem',
  marginBottom: '0.25rem',
}))

const IdentityModal = () => {
  const { t, hidden, buttonEndEnhancer, isOpen, openModal, closeModal } = useIdentity()
  const isPulse = usePulseScope()
  const Title = isPulse ? PulseSubhead : SectionTitle

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='0.5rem'>
      <Title>{t('subscriptionForm:identity_module.section_title')}</Title>
      {/* @ts-ignore */}
      <SDOutlineButton
        onClick={openModal}
        endEnhancer={buttonEndEnhancer}
      >
        {t('subscriptionForm:identity_module.module_title')}
      </SDOutlineButton>
      <IdentityDataError type='error' marginTop='0.5rem' />
      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:identity_module.module_title')}
        sections={<IdentityFormFields />}
      />
    </SpacingWrapper>
  )
}

export default IdentityModal
